<template>
  <v-container fluid>
    <!-- CUPP programs -->
    <v-row dense>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <span class="headline">Download CUPP</span>
          </v-card-title>
          <v-card-subtitle>
            The CUPP programs, hosted on
            <a href="https://zenodo.org/" target="_blank" rel="noopener"
              >Zenodo</a
            >.
          </v-card-subtitle>
          <v-card-text>
            <v-list dense>
              <v-list-item
                v-for="(item, index) in legacyDownloads"
                :key="index"
                :href="item.url"
                target="_blank"
                rel="noopener"
              >
                <v-list-item-icon
                  ><v-icon>mdi-download</v-icon></v-list-item-icon
                >
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                  <v-list-item-subtitle>{{
                    item.subtitle
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { legacyDownloads } from "../util/library";

export default {
  name: "DownloadsView",
  data() {
    return {
      legacyDownloads,
    };
  },
};
</script>

<style scoped></style>
